"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseFileUrl = void 0;
const parseFileUrl = (url) => {
    const parts = url.split('/');
    const domain = parts[2];
    const domainParts = domain.split('.');
    const bucket = domainParts[0];
    const key = `${parts.slice(3).join('/')}`;
    const filename = parts[parts.length - 1];
    return { bucket, key, filename };
};
exports.parseFileUrl = parseFileUrl;
